export const SITE_TITLE = 'THE LIGHT OF EMPIRE';
